import React from "react";
import { motion } from "framer-motion";

const ease = [0.2, 0.65, 0.2, 1];

export function Reveal({ children, delay = 0, className = "", y = 28, ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.85, delay, ease }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

/* Masked line-by-line reveal for hero copy. Each child renders as one line. */
export function SplitLines({ lines, className = "", delay = 0, stagger = 0.12, as: Tag = "span" }) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            className="block"
            initial={{ y: "115%", opacity: 0 }}
            animate={{ y: "0%", opacity: 1 }}
            transition={{ duration: 1, delay: delay + i * stagger, ease: [0.16, 1, 0.3, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function Kicker({ children, className = "", light = false }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className={`h-px w-10 ${light ? "bg-gold-light" : "bg-gold"}`} />
      <span className={`overline ${light ? "text-gold-light" : "text-gold"}`}>{children}</span>
    </div>
  );
}
